import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import {useTranslation} from "react-i18next";
import Flag from "@unibuddy/machop/Buddies/components/Flag/Flag";
import ChatNowButton from "@unibuddy/machop/Blog/components/ChatNowButton/ChatNowButton";
import ThemedLink from "@unibuddy/machop/Navigation/components/ThemedLink/ThemedLink";
import MentorCardBanner from "@unibuddy/machop/Mentor/components/MentorCardBanner/MentorCardBanner";
import MentorCardDegree from "@unibuddy/machop/Mentor/components/MentorCardDegree/MentorCardDegree";
import MentorCardName from "@unibuddy/machop/Mentor/components/MentorCardName/MentorCardName";
import MentorCardSectionItem from "@unibuddy/machop/Mentor/components/MentorCardSectionItem/MentorCardSectionItem";
import MentorCardSeparator from "@unibuddy/machop/Mentor/components/MentorCardSeparator/MentorCardSeparator";

import s from "./MentorPreviewCard.pcss";

const TopRightComp = ({isMatched, degreeLevel}) => {
    if (isMatched && degreeLevel === "Alumni") {
        return (
            <div data-test-id="both">
                <i className="fa fa-star fa-lg" aria-hidden="true" />
                &nbsp; Alumni
            </div>
        );
    } else if (isMatched) {
        return <i data-test-id="star" className="fa fa-star fa-lg" aria-hidden="true" />;
    } else if (degreeLevel === "Alumni") {
        return "Alumni";
    }
    return null;
};

const MentorPreviewCard = props => {
    const {t} = useTranslation("mentorCard");

    return (
        <div className={classNames(s.container, props.className)}>
            <MentorCardBanner
                name={props.firstName}
                className={s.banner}
                lastSeen={props.lastSeen}
                profilePhoto={props.profilePhoto}
                imageLink={`${props.rootUrl}/buddies/students/${props.mentorId}?buddyPosition=${
                    props.buddyPosition
                }`}
                onImageClicked={() => props.onAvatarClicked(props.mentorId)}
                topRight={
                    <TopRightComp isMatched={props.isMatched} degreeLevel={props.degreeLevel} />
                }
            />

            <MentorCardName name={props.firstName} />

            <MentorCardDegree degree={props.degreeName} />

            {props.university ? (
                <p className={s.university} data-test-id="university">
                    {props.university}
                </p>
            ) : null}

            <div className={s.chatNow}>
                <ChatNowButton
                    onChatNow={props.onChatNow}
                    name={props.firstName}
                    className={s.chatNowButton}
                />
            </div>

            <MentorCardSeparator />

            <MentorCardSectionItem label={t("iComeFrom", "I come From")}>
                {props.placeLabel}
                &nbsp;
                {props.isShowCountryFlagEnabled && (
                    <Flag
                        countryCode={props.countryCode}
                        primaryFlag={props.primaryFlag}
                        secondaryFlag={props.secondaryFlag}
                    />
                )}
            </MentorCardSectionItem>

            {props.degreeLevel !== "Alumni" ? (
                <MentorCardSectionItem
                    label={t("previousStudies", "Previous studies")}
                    id="pastQualificationSection"
                    data-test-id="pastQualificationSection"
                >
                    {props.pastQualification}
                </MentorCardSectionItem>
            ) : null}

            <MentorCardSectionItem label={t("aboutMe", "About me")}>
                {props.shortBio}
                ...
            </MentorCardSectionItem>

            <div className={s.seeMore}>
                <ThemedLink
                    id={`read-more-${props.mentorId}`}
                    className={s.seeMoreLink}
                    onClick={() => props.onSeeMoreClicked(props.mentorId)}
                    to={`${props.rootUrl}/buddies/students/${props.mentorId}?buddyPosition=${
                        props.buddyPosition
                    }`}
                >
                    {t("readMore", `Read more about ${props.firstName} ...`, {
                        name: props.firstName,
                    })}
                </ThemedLink>
            </div>
        </div>
    );
};
MentorPreviewCard.propTypes = {
    mentorId: PropTypes.string.isRequired,
    profilePhoto: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    degreeName: PropTypes.string.isRequired,
    degreeLevel: PropTypes.string.isRequired,
    pastQualification: PropTypes.string.isRequired,
    countryCode: PropTypes.string.isRequired,
    placeLabel: PropTypes.string.isRequired,
    shortBio: PropTypes.string.isRequired,
    rootUrl: PropTypes.string.isRequired,
    onChatNow: PropTypes.func.isRequired,
    onAvatarClicked: PropTypes.func,
    onSeeMoreClicked: PropTypes.func,
    isMatched: PropTypes.bool,
    lastSeen: PropTypes.string,
};

MentorPreviewCard.defaultProps = {
    lastSeen: null,
    isMatched: false,
    onAvatarClicked: () => true,
    onSeeMoreClicked: () => true,
};

export default MentorPreviewCard;
